import size from 'lodash/size';
import each from 'lodash/each';
import * as moment from 'moment-timezone';

export class UtilityClass {
  constructor() {}

  // Sometimes this is preferred to extract the date than moment.
  // This uses far more less resource than moment().
  public static getOrderDate(datetime: string, removeHyphen: boolean = false): string {
    if (datetime) {
      if (removeHyphen) {
        return datetime.substring(0, 10).replace(/-/g, '');
      } else {
        return datetime.substring(0, 10);
      }
    } else {
      return '';
    }
  }

  public static getOrderDateToNumber(datetime: string): number {
    if (datetime) {
      return +datetime.substring(0, 10).replace(/-/g, '');
    } else {
      return 0;
    }
  }

  public static isIPAddress(val: string): boolean {
    if (
      !val.match(
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
      )
    ) {
      return false;
    } else {
      return true;
    }
  }

  public static validateEmail(email: string): boolean {
    if (size(email) == 0) return false;

    return !!email.match(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
  }

  public static convertIntArrayToBinaries(binaries: Int8Array): number[][] {
    let retVal: number[][] = [];
    each(binaries, binary => {
      let defaultMap: number[] = [0, 0, 0, 0, 0, 0, 0, 0];
      const binaryValue: number[] = binary
        .toString(2)
        .split('')
        .reverse()
        .map(value => {
          return +value;
        });

      each(binaryValue, (value, index) => {
        defaultMap[index] = value;
      });

      retVal.push(defaultMap);
    });

    return retVal;
  }

  public static asyncCallWithTimeout(promise: Promise<any>, timeoutInMS: number = 10000): Promise<any> | undefined {
    let timeoutPromiseRef;

    const timeoutPromise = new Promise((_resolve, reject) => {
      timeoutPromiseRef = setTimeout(() => reject(new Error('Timeout in async call')), timeoutInMS);
    });

    return Promise.race([timeoutPromise, promise]).then(result => {
      clearTimeout(timeoutPromiseRef);
      return result;
    });
  }

  /**
   * Mainly used to parse order dates from device timezone to specified timezone without converting it.
   *
   * e.g
   * Account timezone = "Europe/London"
   * Device timezone = "Australia/Melbourne"
   *
   *
   * order.eta = "2022-05-03 10:24:34";
   * moment(order.eta); => 10:24AM AEST
   *
   * The value above assumes the timezone of the device, which is incorrect.
   * This function will parse it correctly based on the provided timezone.
   *
   * @param datetime (string) The time to parse in "YYYY-MM-DD HH:mm:ss" format
   * @param timezone (timezone) The timezone used to parse the time.
   * @returns Moment object
   * */
  public static parseTimeToTimezone(
    datetime: string,
    timezone: string,
    allowedFormat: 'YYYY-MM-DD HH:mm:ss' = 'YYYY-MM-DD HH:mm:ss',
  ) {
    return moment.tz(datetime, allowedFormat, timezone);
  }

  /**
   * Returns the current time based on the specified timezone
   *
   * @param timezone The timezone used to generate the current time
   * @returns Moment object
   */
  public static momentNow(timezone: string) {
    return moment().tz(timezone);
  }

  public static GetCurrencySymbolForCurrencyType(currencyType: string) {
    const currencySymbols = {
      EUR: '€', // Euro
      CRC: '₡', // Costa Rican Colón
      GBP: '£', // British Pound Sterling
      ILS: '₪', // Israeli New Sheqel
      INR: '₹', // Indian Rupee
      JPY: '¥', // Japanese Yen
      KRW: '₩', // South Korean Won
      NGN: '₦', // Nigerian Naira
      PHP: '₱', // Philippine Peso
      PLN: 'zł', // Polish Zloty
      PYG: '₲', // Paraguayan Guarani
      THB: '฿', // Thai Baht
      UAH: '₴', // Ukrainian Hryvnia
      VND: '₫', // Vietnamese Dong
    };

    return currencySymbols[currencyType] || '$';
  }
}
